import '@angular/localize/init';
export * from './lib/feature-tax-wage-list.module';

export * from './lib/tax-wage-list/feature-tax-wage-list.component';
